import React from "react"
import { POE_KEY } from "./constants/peoKeys"
import { taggingCancelEvent, taggingCloseEvent, taggingOpenEvent, taggingUpdateEvent } from "./helpers/taggings"

export const useFiocStatus = ({ fiocStatus, closeRedirectURL, history }) => {
    const [openModal, setOpenModal ] = React.useState(false)

    React.useEffect(() => {
        const { showFioc } = fiocStatus.toJS()
        setOpenModal(showFioc)

        if (showFioc) {
            taggingOpenEvent()
        }
    }, [fiocStatus])

    const closeModal = (isCancel) => {
        isCancel
            ? taggingCancelEvent()
            : taggingCloseEvent()

        history.push(closeRedirectURL)
    }

    const redirectToUpdateFioc = () => {
        taggingUpdateEvent()
        history.push('/myprofile/edit#fioc')
    }


    const getPOEKeys = (contractIndex) => {
        return POE_KEY[contractIndex]
    }

    return { openModal, closeModal, redirectToUpdateFioc, getPOEKeys }
}
